import { DashboardOverviewData } from 'shared/api/api';

export const GET_DASHBOARD_OVERVIEW_TABLE = 'getDashboardOverviewTable';
export const GET_DASHBOARD_OVERVIEW_GRAPH = 'GET_DASHBOARD_OVERVIEW_GRAPH';
export interface DashboardOverviewState {
	loading: boolean;
	data?: DashboardOverviewData;
	graphData?: DashboardOverviewData;
	graphLoading: boolean;
}
